import { AbstractFreewheelClass } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFreewheelClass';
import { IFreewheelRequest } from 'tag/ts/tag/ads/freewheel/interfaces/IFreewheelRequest';
import { IFreewheelRequestFactory } from 'tag/ts/tag/ads/freewheel/interfaces/IFreewheelRequestFactory';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description Base class for all Freewheel factories
 */
export abstract class AbstractFreewheelRequestFactory extends AbstractFreewheelClass implements IFreewheelRequestFactory {

	protected constructor( argument: ITagAbstractClassArgument ) {
		super( argument );
	}

	/**
	 * @description Returns an instance of IFreewheelRequest
	 * @return {IFreewheelRequest}
	 */
	abstract createRequest(): IFreewheelRequest;
}